/// Themes for the application

import { createTheme } from "@mui/material/styles";
import { lightColors, darkColors } from "./color";

declare module "@mui/material/styles" {
  interface Theme {
    status: {
      danger: string;
    };
  }
  interface ThemeOptions {
    status?: {
      danger?: string;
    };
  }
  interface Palette {
    secondaryBackground: {
      main: string;
      contrastText: string;
    };
  }
  interface PaletteOptions {
    secondaryBackground?: {
      main?: string;
      contrastText?: string;
    };
  }
}

/**
 * Light Theme for the application
 */
export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: lightColors.primary,
    },
    secondary: {
      main: lightColors.secondary,
    },
    background: {
      default: lightColors.background,
      paper: lightColors.material,
    },
    secondaryBackground: {
      main: lightColors.secondaryBackground,
      contrastText: lightColors.secondaryBackgroundText,
    },
  },
  typography: {
    fontFamily: "Lato",
  },
});

/**
 * Dark Theme for the application
 */
export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: darkColors.primary,
    },
    secondary: {
      main: darkColors.secondary,
    },
    background: {
      default: darkColors.background,
      paper: darkColors.material,
    },
    secondaryBackground: {
      main: darkColors.secondaryBackground,
      contrastText: darkColors.secondaryBackgroundText,
    },
  },
  typography: {
    fontFamily: "Lato",
  },
});
